// extracted by mini-css-extract-plugin
module.exports = {"filterFieldset":"Checkboxes_filterFieldset__q5sqf","filterFieldsetLegend":"Checkboxes_filterFieldsetLegend__QGHq_"};